var GEO_DATA, Location, LocationBar, base, placeholderState, whichKeyAlias,
  slice = [].slice;

Location = require('../helper/m_location_helper');

GEO_DATA = require('../helper/m_searchbar_helper').GEO_DATA;

placeholderState = require('../helper/m_common').placeholderState;

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

module.exports = LocationBar = (function() {
  function LocationBar(arg) {
    var data, division, el, env, initialLocation, initialLocationData, ref, ref1;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.previousValue = '';
    this.originalValue = '';
    this.hasDualSearch = (ref = Groupon.LS.experiments) != null ? ref['LS-2333-ShowDualSearch'] : void 0;
    this.$input = this.$el.find('#location, #ls-location');
    if (!Cookie.get('ell')) {
      if (division = Location.getDivision()) {
        Location.setELLCookie(division.lat + ',' + division.lng);
      }
    }
    initialLocation = Location.getInitialLocation();
    initialLocationData = Location.getInitialLocationData();
    data = {
      manual: false,
      city: (ref1 = Groupon.division) != null ? ref1.name : void 0
    };
    if (initialLocationData) {
      data = _.extend({}, data, _.pick.apply(_, [initialLocationData, 'lat', 'lng'].concat(slice.call(GEO_DATA))));
    }
    this.$input.data(data);
    if (!_.isBlank(initialLocation)) {
      placeholderState.set(this.$input, 'hide');
      this.$input.val(initialLocation);
      this.originalValue = initialLocation;
      switch (this.env) {
        case 'mobile':
          $('.t-division-link a').text(initialLocation);
      }
    }
    this.bind();
    switch (env) {
      case 'desktop':
        this.setupDesktop();
        break;
      case 'mobile':
        this.setupMobile();
    }
  }

  LocationBar.prototype.setLocation = LocationBar.val;

  LocationBar.prototype.val = function(value, options) {
    var currentVal, silent;
    if (options == null) {
      options = {};
    }
    silent = options.silent;
    if (value != null) {
      this.$input.val(value).removeClass('prompting');
      if (!silent) {
        return this.trigger('manual', value);
      }
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal)) {
        return null;
      }
      return currentVal.trim();
    }
  };

  LocationBar.prototype.bind = function() {
    return this.$input.on({
      'focusin.location': (function(_this) {
        return function() {
          _this.storeLocation();
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', _this.$input.val());
          }
          _this.$input.val('');
        };
      })(this),
      'focusout.location': (function(_this) {
        return function() {
          _this.storeLocation();
          _this.$input.val(_this.previousValue);
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', null);
          }
          _this.$input.trigger('focusin.searchMobile');
        };
      })(this),
      'manual.location': (function(_this) {
        return function() {
          _this.$input.data({
            manual: true
          });
        };
      })(this),
      'input.location': (function(_this) {
        return function() {
          if (_this.$input.data('manual') !== true) {
            _this.$input.trigger('manual');
          }
        };
      })(this)
    });
  };

  LocationBar.prototype.restoreLocation = function() {
    var value;
    if ((value = this.originalValue).length) {
      return this.$input.val(value);
    }
  };

  LocationBar.prototype.storeLocation = function() {
    var value;
    if (!_.isBlank(value = this.$input.val())) {
      return this.previousValue = value;
    }
  };

  LocationBar.prototype.setupDesktop = function() {};

  LocationBar.prototype.setupMobile = function() {
    return this.$input.on({
      'keydown': (function(_this) {
        return function(e) {
          if (whichKeyAlias(e) === 'Enter') {
            return _this.$el.trigger('submit', 'manual');
          }
        };
      })(this)
    });
  };

  return LocationBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  LocationBar: LocationBar
});

//# sourceMappingURL=data:application/json;base64,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
